import { useEffect, useMemo, useRef, useState } from "react";
import Auther from "./Auther";
import "./Content.less";
import { TrendItem, TrendType } from "@/config/types/trend";
import { transNum, transTrendTime } from "@/utils/utils";
import ShowMoreContentPopup from "./ShowMoreContentPopup";
import TagList from "@/containers/trend-audit/detail-components/TagList";
import classNames from "classnames";
import sdicHomeEmit from "@/utils/prototal";

interface ContentProps {
  theme: "light" | "dark";
  data: TrendItem;
  hideAuthor?: boolean; // 是否隐藏发布者，只有审核状态的图文详情，才会隐藏
  isAuditPage?: boolean; // 是否是审核页
  showTrendJob?: boolean; // 是否显示动态关联职位
}

export default function Content({ theme, data, hideAuthor, isAuditPage }: ContentProps) {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [showMore, setShowMore] = useState(false); // 是否显示查看更多的按钮
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (theme === "dark") {
      const htmlFontSize: string = document.getElementsByTagName("html")[0].style.fontSize;
      const lineHeight = (54 * +htmlFontSize?.split("px")[0]) / 16;
      const height = textRef.current?.clientHeight || 0;
      setShowMore(height > lineHeight * 2);
    }
  }, [theme]);

  const content = useMemo(() => {
    if (data.type === TrendType.ARTICLE) {
      let index = -1;

      /**
       * 给图片添加标号，主要是用于在点击图片预览时，方便知道点击的是哪个图片；
       * 有同学可能会想，使用点击的图片地址与所有图片的地址进行匹配，但若文章中存在
       * 多个相同的图片时，则就判断不出来点击的是哪张了。
       */
      return data.content.replace(/<img/gi, () => {
        index++;
        return `<img data-index=${index} `;
      });
    }
    return data.content;
  }, [data.type, data.content]);

  /**
   * 点击文章类型动态中的图片，使用APP内jsapi方法进行预览。
   * 并查出该文章中所有的图片，形成列表。
   */
  const handleImgClick = (event: any) => {
    if (data.type !== TrendType.ARTICLE || event.target.nodeName.toLowerCase() !== "img") {
      return;
    }

    const images: { url: string; title: string }[] = [];
    const currIndex = Number(event.target.getAttribute("data-index") || 0); // 当前打开的是第几张图

    textRef.current?.querySelectorAll("img")?.forEach((img) => {
      if (img.src) {
        images.push({ url: img.src, title: img.title || "" });
      }
    });

    if (images.length) {
      sdicHomeEmit("browseImage", {
        images,
        currIndex,
      });
    }
  };

  return (
    <div className={`content-wrap content-wrap-${theme}`}>
      {/* 关联职位-审核页才有 */}
      {/* {isAuditPage && data.type === TrendType.VIDEO && (
        <div className="trend-job-top">
          <TrendJob />
        </div>
      )} */}
      {!hideAuthor && <Auther theme={theme} isAuditPage={isAuditPage} data={data} />}
      {/* {isAuditPage && theme === "dark" && <DenyTip data={data} theme={theme} />} */}
      {theme === "light" && data.title && (
        <div className="trend-title" dangerouslySetInnerHTML={{ __html: data.title }}></div>
      )}

      {/* 文章类型的动态，发布时间在上方 */}
      {data.type === TrendType.ARTICLE && (
        <div className="trend-publish-info top">
          {transNum(data.viewNum)}阅读 发布于{transTrendTime(data.createTime || "")}{" "}
          {data.city || data.province}
        </div>
      )}
      <div
        className={classNames("trend-text", {
          line2: showMore,
          article: data.type === TrendType.ARTICLE,
        })}
        ref={textRef}
        onClick={handleImgClick}
      >
        {showMore && (
          <span className="show-more" onClick={() => setShowPopup(true)}>
            展开全文
          </span>
        )}
        {theme === "dark" && data.title && (
          <div dangerouslySetInnerHTML={{ __html: data.title }}></div>
        )}
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
        {theme === "dark" && Array.isArray(data.topics) && (
          <span className="trend-topic">
            {data.topics.map((item) => (
              <div
                key={item.paramId}
                className={classNames("trend-topic-item", { sensi: item.sensi === "true" })}
                onClick={(e: any) => e.stopPropagation()}
                // to="/"
                // to={`${_route.TOPIC_TREND}?id=${item.paramId}`}
              >
                #{item.paramName}
              </div>
            ))}
          </span>
        )}
      </div>

      {theme === "light" && Array.isArray(data.topics) && (
        <div className="trend-topic">
          {data.topics.map((item) => (
            <div
              key={item.paramId}
              className={classNames("trend-topic-item", { sensi: item.sensi === "true" })}
              onClick={(e: any) => e.stopPropagation()}
              // to="/"
              // to={`${_route.TOPIC_TREND}?id=${item.paramId}`}
            >
              #{item.paramName}
            </div>
          ))}
        </div>
      )}
      {/* 关联职位 */}
      {/* {isAuditPage && data.type === TrendType.PICTURE ? <TrendJob /> : null} */}
      {data.type !== TrendType.ARTICLE && (
        <div className="trend-publish-info">
          发布于{transTrendTime(data.createTime || "")} {data.city || data.province}
        </div>
      )}
      {isAuditPage && <TagList theme={theme} auditTags={data.auditTags} />}
      <ShowMoreContentPopup
        visible={showPopup}
        data={data}
        theme={theme}
        isAuditPage={isAuditPage}
        onClose={() => setShowPopup(false)}
      />
    </div>
  );
}
